var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPensionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-animate",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pension-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#F3F3F3",
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(14.000000, 16.000000)",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-1",
    points: "36.4790667 -2.30926389e-14 28.2470667 18.596 27.0297333 31.1493333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.108,29.0962667 C34.84,29.2096 34.552,29.3282667 34.2466667,29.4482667 C27.8533333,31.9616 13.3933333,35.5282667 3.19744231e-14,23.8509333",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2473333,18.5962667 L13.5627891,14.9126296 C12.5639752,14.6620758 11.5381667,15.2108885 11.1923282,16.180838 L6.79266667,28.5202667 L6.79266667,28.5202667",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.2226667,
    y1: 11.8762667,
    x2: 14.2866667,
    y2: 7.60293333,
    id: "Stroke-7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionIcon);
export default __webpack_public_path__ + "static/media/pension-icon.d5bf9a30.svg";
export { ForwardRef as ReactComponent };